export default {
  proxy: "https://connect-cors-anywhere.azurewebsites.net/",
  currentEnv: "dev",
  environment: {
    dev: {
      azure: {

      },
      api: {
        hostname: "strapi-container.mangobay-2f61d501.northeurope.azurecontainerapps.io:443",
        clientId: "dcc8ca4a-42ce-4da8-90a1-2bfc2ad0feb2",
        scope: "openid dcc8ca4a-42ce-4da8-90a1-2bfc2ad0feb2  profile",
        personalLoginUrl: "https://thekitchenofthefuture.b2clogin.com/thekitchenofthefuture.onmicrosoft.com/oauth2/v2.0/token?p=B2C_1_ROPC",
        subscriptionkey: "964bf762168d4403a69040dc14858380",
        base: {
          languages: "/api/i18n/locales",
          labels: "/api/labels",
          createUser: "/api/users"
        }
      },
    },
    prod: {
      api: {
        hostname: "strapi-container.mangobay-2f61d501.northeurope.azurecontainerapps.io:443",
        clientId: "dcc8ca4a-42ce-4da8-90a1-2bfc2ad0feb2",
        scope: "openid dcc8ca4a-42ce-4da8-90a1-2bfc2ad0feb2  profile",
        personalLoginUrl: "https://thekitchenofthefuture.b2clogin.com/thekitchenofthefuture.onmicrosoft.com/oauth2/v2.0/token?p=B2C_1_ROPC",
        subscriptionkey: "964bf762168d4403a69040dc14858380",
        base: {
          languages: "/api/i18n/locales",
          labels: "/api/labels",
          createUser:"/api/users"
        }
      },
    }
  },
  env() {
    return this.environment[this.currentEnv];
  },
 headers() {
   return {
      'Authorization': `Bearer a440269fb18e50b507ff11bb1d71361b647ae8a0057dea43c14f3753b444f577e78f1d8c1332f3c6dd820453bca399a383af72bb57860d2a885159809d5612bb675e70e560d0af508540e837c97a606e636e9748327a6fd27787b1337dfbb16fe1a16e615e172d9d2f261a4f45df80f024b507e1f3d7d4c3e0ada5612ba81c60`,
    };
  },
 
  url(type) {
    return this.env().api.hostname + this.env().api.base[type];
  },

}
